<template>
  <dara-modal
    ref="modal"
    :title="$t('creating-department')"
    :full-line="true"
    v-bind="$attrs"
    v-on="$listeners">
    <template #content>
      <dara-p weight="strong" margin="lg">
        {{ $t('creating-department-info') }}
      </dara-p>
      <div class="mb-3">
        <dara-input
          v-model="department.name"
          :label="$t('departments-name') + '*'"
          :name="$t('department-name-field')"
          type="text"
          rules="required|min:2"
          class="mb-5"
          :placeholder="$t('department-name-placeholder')" />
      </div>
      <div>
        <dara-input
          v-model="department.description"
          :label="$t('description')"
          :name="$t('description-field')"
          type="text"
          :placeholder="$t('department-description-placeholder')" />
      </div>
    </template>
    <template #footer>
      <dara-button
        class="btn btn-success"
        size="sm"
        :disabled="!department.name"
        @click="save()">
        {{ $t('create') }}
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>
import { saveDepartment } from '@/modules/department/department.service';
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';

export default {
  name: 'DaraModalConfirm',
  props: {
    closeAfterConfirm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      department: {},
    };
  },
  methods: {
    save() {
      saveDepartment(this.department)
        .then(department => {
          this.$emit('saved', department);
          if (this.closeAfterConfirm) {
            this.$refs.modal.close();
          }
        })
        .catch(err => {
          if (err.response.status === 400 && err.response.data.errors[0].field === 'name' && err.response.data.errors[0].validation === 'unique') {
            toastError(translate('the-company-already-has-a-department-with-this-name'));
          } else if (err.response.data.errors.includes('value too long')) {
            toastError(translate('the-department-description-is-too-long'));
          } else {
            toastError(translate('error-on-saving-department'));
          }
          if (this.closeAfterConfirm) {
            this.$refs.modal.close();
          }
        });
    },
  },
};
</script>
